import React, { useEffect, useState } from "react";
import { Table, Button, Form, Modal, Row, Col } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import {
  FiEdit,
  FiTrash,
  FiEye,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";

const API_HOST = process.env.REACT_APP_API_URL;
const cookies = new Cookies();

const TasasCambio = () => {
  const id_Usuario = cookies.get("id_Usuario");

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [errors, setErrors] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);

  const [formData, setFormData] = useState({
    moneda: "",
    tasa: "",
    fechaConsulta: new Date().toLocaleDateString("en-CA", {
      timeZone: "America/Tegucigalpa",
    }),
    idUsuario: id_Usuario,
  });

  const [editingId, setEditingId] = useState(null);

  // Opciones para items por página
  const itemsPerPageOptions = [5, 10, 20, 50];

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    filterData();
  }, [searchTerm, data]);

  const fetchData = async () => {
    const bearertoken = cookies.get("token");
    try {
      const response = await fetch(`${API_HOST}/tasaCambio`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${bearertoken}`,
          API: "457896",
        },
      });
      const result = await response.json();
      setData(result);
      setFilteredData(result);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire("Error", "No se pudieron cargar las tasas de cambio", "error");
    }
  };

  const filterData = () => {
    const filtered = data.filter(
      (item) =>
        item.moneda.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.tasa.toString().includes(searchTerm.toLowerCase())
    );
    setFilteredData(filtered);
    setCurrentPage(0);
  };

  const validateForm = () => {
    const newErrors = {};

    if (
      !formData.moneda ||
      formData.moneda.length < 2 ||
      formData.moneda.length > 50
    ) {
      newErrors.moneda = "La moneda debe tener entre 2 y 50 caracteres";
    }

    if (!formData.tasa || isNaN(formData.tasa)) {
      newErrors.tasa = "La tasa debe ser un número válido";
    }

    if (!formData.fechaConsulta) {
      newErrors.fechaConsulta = "La fecha de consulta es requerida";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleView = (item) => {
    setSelectedItem(item);
    setShowViewModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };

  const handleShowModal = (item = null) => {
    if (item) {
      const formattedItem = {
        ...item,
        fechaConsulta: item.fechaConsulta.split("T")[0],
      };
      setFormData(formattedItem);
      setEditingId(item.idTasa);
    } else {
      setFormData({
        moneda: "",
        tasa: "",
        fechaConsulta: new Date().toLocaleDateString("en-CA", {
          timeZone: "America/Tegucigalpa",
        }),
        idUsuario: id_Usuario,
      });
      setEditingId(null);
    }
    setErrors({});
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: null });
    }
  };

  const handleSubmit = async () => {
    const bearertoken = cookies.get("token");
    if (!validateForm()) {
      Swal.fire(
        "Error",
        "Por favor corrija los errores en el formulario",
        "error"
      );
      return;
    }

    const method = editingId ? "PUT" : "POST";
    const url = editingId ? `/tasaCambio/${editingId}` : "/tasaCambio";
    const dataToSubmit = { ...formData };

    try {
      const response = await fetch(`${API_HOST + url}`, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearertoken}`,
          API: "457896",
        },
        body: JSON.stringify(dataToSubmit),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error en la solicitud");
      }

      Swal.fire(
        "Éxito",
        editingId
          ? "Tasa actualizada correctamente"
          : "Tasa creada correctamente",
        "success"
      );
      fetchData();
      handleCloseModal();
    } catch (error) {
      Swal.fire(
        "Error",
        error.message || "Hubo un problema en la operación",
        "error"
      );
    }
  };

  const handleDelete = async (id) => {
    const bearertoken = cookies.get("token");
    Swal.fire({
      title: "¿Estás seguro?",
      text: "No podrás revertir esto!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await fetch(`${API_HOST}/tasaCambio/${id}`, {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${bearertoken}`,
              API: "457896",
            },
          });
          Swal.fire("Eliminado!", "El registro ha sido eliminado.", "success");
          fetchData();
        } catch (error) {
          Swal.fire("Error", "No se pudo eliminar el registro", "error");
        }
      }
    });
  };

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(0);
  };

  const pageCount = Math.ceil(filteredData.length / itemsPerPage);
  const displayedData = filteredData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(dateString).toLocaleDateString("es-ES", options);
  };

  return (
    <div className='container-fluid mt-4'>
      <div className='card border-0 shadow-sm'>
        <div className='card-body'>
          <div className='d-flex justify-content-between mb-4'>
            <h5 className='card-title mb-0'>Gestión de Tasas de Cambio</h5>
            <Button
              variant='success'
              onClick={() => handleShowModal()}
              size='sm'
            >
              Agregar Nueva
            </Button>
          </div>

          <div className='d-flex justify-content-between mb-3'>
            <Form.Control
              type='text'
              placeholder='Buscar por moneda o tasa...'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ width: "70%" }}
              className='border'
            />
            <div className='d-flex align-items-center'>
              <span className='me-2 text-muted'>Mostrar:</span>
              <Form.Select
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
                style={{ width: "80px" }}
                className='border'
                size='sm'
              >
                {itemsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>

          <div className='table-responsive'>
            <Table hover className='mb-0'>
              <thead>
                <tr>
                  <th className='border-top-0'>ID</th>
                  <th className='border-top-0'>Moneda</th>
                  <th className='border-top-0'>Tasa</th>
                  <th className='border-top-0'>Fecha Consulta</th>
                  <th className='border-top-0 text-end'>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {displayedData.map((item) => (
                  <tr key={item.idTasa}>
                    <td className='text-muted'>{item.idTasa}</td>
                    <td>{item.moneda}</td>
                    <td>{item.tasa}</td>
                    <td>{(item.fechaConsulta).slice(0,10)}</td>
                    <td className='text-end'>
                      <Button
                        variant='outline-warning'
                        onClick={() => handleShowModal(item)}
                        className='me-2'
                        title='Editar'
                        size='sm'
                      >
                        <FiEdit />
                      </Button>
                      <Button
                        variant='outline-danger'
                        onClick={() => handleDelete(item.idTasa)}
                        className='me-2 action-btn'
                        title='Eliminar'
                        size='sm'
                      >
                        <FiTrash />
                      </Button>
                      <Button
                        variant='outline-primary'
                        onClick={() => handleView(item)}
                        title='Ver detalles'
                        size='sm'
                      >
                        <FiEye />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <div className='d-flex justify-content-between align-items-center mt-3'>
            <div className='text-muted small'>
              Mostrando {displayedData.length} de {filteredData.length}{" "}
              registros
            </div>
            <ReactPaginate
              previousLabel={<FiChevronLeft size={14} />}
              nextLabel={<FiChevronRight size={14} />}
              pageCount={pageCount}
              onPageChange={handlePageClick}
              containerClassName={"pagination mb-0"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
              breakLabel='...'
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
            />
          </div>
        </div>
      </div>

      {/* Modal para agregar/editar */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>
            {editingId ? "Editar" : "Agregar"} Tasa de Cambio
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Moneda
                  </Form.Label>
                  <Form.Control
                    type='text'
                    name='moneda'
                    value={formData.moneda}
                    onChange={handleChange}
                    isInvalid={!!errors.moneda}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.moneda}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Tasa
                  </Form.Label>
                  <Form.Control
                    type='number'
                    step='0.0001'
                    name='tasa'
                    value={formData.tasa}
                    onChange={handleChange}
                    isInvalid={!!errors.tasa}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.tasa}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Fecha de Consulta
                  </Form.Label>
                  <Form.Control
                    type='date'
                    name='fechaConsulta'
                    value={formData.fechaConsulta}
                    onChange={handleChange}
                    isInvalid={!!errors.fechaConsulta}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.fechaConsulta}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button variant='outline-secondary' onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant='primary' onClick={handleSubmit}>
            {editingId ? "Actualizar" : "Guardar"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para ver detalles */}
      <Modal show={showViewModal} onHide={handleCloseViewModal} centered>
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>
            <FiEye className='me-2 text-primary' />
            Detalles de la Tasa de Cambio
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem && (
            <div>
              <div className='mb-3'>
                <h6 className='text-muted mb-2'>Información Básica</h6>
                <div className='ps-3'>
                  <p className='mb-2'>
                    <span className='fw-medium'>ID:</span> {selectedItem.idTasa}
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Moneda:</span>{" "}
                    {selectedItem.moneda}
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Tasa:</span> {selectedItem.tasa}
                  </p>
                  <p className='mb-0'>
                    <span className='fw-medium'>Fecha Consulta:</span>{" "}
                    {(selectedItem.fechaConsulta).slice(0,10)}
                  </p>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button variant='outline-secondary' onClick={handleCloseViewModal}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TasasCambio;
